import styles from './IppicaUltimiRisultatiCardCompetitor.module.scss';

export type IppicaUltimiRisultatiCardCompetitorProps = {
  quota?: string;
  position?: number;
  nomeCavallo?: string;
  nomeFantino?: string;
  numeroCavallo?: number;
};

export const IppicaUltimiRisultatiCardCompetitor = ({
  quota,
  position,
  nomeCavallo,
  nomeFantino,
  numeroCavallo,
}: IppicaUltimiRisultatiCardCompetitorProps) => {
  return (
    <div className={`${styles.container} ${position === 1 && styles.first}`}>
      {position && <span className={styles.position}>{position}</span>}
      <ul className={styles.infoList}>
        <li>
          {nomeCavallo} <span className={styles.number}>{numeroCavallo}</span>
        </li>
        <li>{nomeFantino}</li>
      </ul>
      {quota && (
        <ul className={styles.quotaContainer}>
          {/* TODO label */}
          <li>Vincente</li>
          <li>{quota ?? '-'}</li>
        </ul>
      )}
    </div>
  );
};
